module.exports = __webpack_public_path__ + "img/mile2-m@2.db85130a.webp";